if (!customElements.get('afr-pdp-savings')) {
  class AfrPdpSavings extends HTMLElement {
    connectedCallback() {
      if (typeof PRODUCT_EVENT === 'undefined') return;
      this.eventName = `${PRODUCT_EVENT.updatedVariant}${this.dataset.sectionId}`;
      this.updateVariant = event => {
        const variant = event.detail?.currentVariant;
        const price = Number(variant?.price);
        const original = Number(variant?.compare_at_price);
        this.hidden = this.dataset.priceHidden === 'true' || !variant || !Number.isFinite(price) || !Number.isFinite(original) || price < 50000 || original <= price;
        const page = this.closest('.afr-pdp-page');
        const widget = page?.querySelector('tamara-widget');
        if (widget) {
          widget.hidden = !variant;
          if (variant && Number.isFinite(price)) {
            widget.setAttribute('amount', (price / 100).toFixed(2));
            window.TamaraWidgetV2?.refresh?.();
          }
        }
      };
      document.addEventListener(this.eventName, this.updateVariant);
      const initial = document.getElementById(`CurrentVariantInfo__${this.dataset.sectionId}`);
      if (initial?.textContent) {
        try { this.updateVariant({ detail: { currentVariant: JSON.parse(initial.textContent) } }); } catch (_) {}
      }
    }
    disconnectedCallback() {
      if (this.eventName) document.removeEventListener(this.eventName, this.updateVariant);
    }
  }
  customElements.define('afr-pdp-savings', AfrPdpSavings);
}

if (!customElements.get('afr-pdp-linked-rating')) {
  class AfrPdpLinkedRating extends HTMLElement {
    connectedCallback() {
      this.followReviews = event => {
        const anchor = event.target.closest('a');
        if (!anchor || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const reviews = document.getElementById(this.dataset.target);
        if (!reviews) return;
        event.preventDefault();
        reviews.setAttribute('tabindex', '-1');
        reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        reviews.focus({ preventScroll: true });
      };
      this.addEventListener('click', this.followReviews);
    }
    disconnectedCallback() { this.removeEventListener('click', this.followReviews); }
  }
  customElements.define('afr-pdp-linked-rating', AfrPdpLinkedRating);
}


if (!customElements.get('afr-review-empty')) {
  class AfrReviewEmpty extends HTMLElement {
    connectedCallback() {
      this.widget = this.closest('.afr-pdp-reviews-full')?.querySelector('.afr-pdp-full-review-widget');
      if (!this.widget) return;
      this.seenReviews = this.seenReviews || Number(this.dataset.reviewCount) > 0;
      const whatsapp = this.querySelector('[data-review-help-whatsapp]');
      const existing = document.querySelector('.afr-support-whatsapp[href]');
      if (whatsapp && existing) {
        try {
          const url = new URL(existing.href);
          if (url.hostname === 'wa.me' || url.hostname === 'api.whatsapp.com') {
            url.searchParams.set('text', [this.dataset.message, this.dataset.productTitle, this.dataset.productUrl].join('\n'));
            whatsapp.href = url.href;
            whatsapp.hidden = false;
          }
        } catch (_) {}
      }
      this.syncReviews = () => {
        const writeButton = this.querySelector('[data-afr-write-review]');
        const nativeWrite = Array.from(this.widget.querySelectorAll('button,a,[role="button"],.write_review_container')).find(node => /^(write\s+(a\s+)?review|اكتب\s+(?:تقييم|مراجع)|أضف\s+تقييم|إضافة\s+تقييم|قيّم)/i.test(node.textContent.trim()) && !node.closest('form'));
        if (writeButton) {
          writeButton.hidden = !nativeWrite;
          writeButton.onclick = () => nativeWrite?.click();
        }
        const normalize = value => String(value).replace(/[٠-٩]/g, c => c.charCodeAt(0) - 1632).replace(/[۰-۹]/g, c => c.charCodeAt(0) - 1776);
        const counts = [];
        this.widget.querySelectorAll('[data-review-count],[data-rating-count]').forEach(node => {
          for (const name of ['data-review-count', 'data-rating-count']) {
            const value = normalize(node.getAttribute(name) || '').replace(/[,\s]/g, '');
            if (/^\d+$/.test(value)) counts.push(Number(value));
          }
        });
        const text = normalize(this.widget.textContent.slice(0, 700));
        const match = text.match(/(?:reviews?|التقييمات|تقييمات|التقييم|المراجعات|مراجعات|آراء)\s*[([]\s*([\d,]+)\s*[)\]]/i);
        if (match) counts.push(Number(match[1].replace(/,/g, '')));
        const publishedCard = Array.from(this.widget.querySelectorAll('.areviews_slide_image_details')).some(card => card.querySelector('.user_info_container,.main_container_review_stars') && card.textContent.trim());
        this.seenReviews = this.seenReviews || counts.some(count => count > 0) || publishedCard;
        const knownZero = this.dataset.countKnown === 'true' && Number(this.dataset.reviewCount) === 0;
        this.hidden = this.seenReviews || !(knownZero || counts.some(count => count === 0));
      };
      this.syncReviews();
      this.observer = new MutationObserver(() => {
        if (this.pending) return;
        this.pending = true;
        queueMicrotask(() => {
          this.pending = false;
          if (this.isConnected) this.syncReviews();
        });
      });
      this.observer.observe(this.widget, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-review-count', 'data-rating-count'] });
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  }
  customElements.define('afr-review-empty', AfrReviewEmpty);
}


if (!customElements.get('afr-pdp-layout')) {
  class AfrPdpLayout extends HTMLElement {
    connectedCallback() {
      this.page = this.querySelector('.afr-pdp-page');
      this.media = this.page?.querySelector(':scope > .product-template__media-wrapper');
      this.content = this.page?.querySelector(':scope > .product-template__content-wrapper');
      this.panel = this.content?.querySelector('.product-template__content__container');
      if (!this.media || !this.panel) return;
      this.reviews = this.media.querySelector(':scope > .afr-pdp-reviews-full') || this.page.querySelector(':scope > .afr-pdp-reviews-full');
      this.mobile = matchMedia('(max-width:767px)');
      this.titleRating = this.panel.querySelector('.afr-pdp-title-rating');
      this.brandRow = this.panel.querySelector('.afr-pdp-brand');
      if (this.titleRating && this.brandRow) { this.ratingOrigin = document.createElement('template'); this.titleRating.before(this.ratingOrigin); }
      this.stock = this.panel.querySelector('.product-info__inventory-status-wrapper');
      this.quantityRow = this.panel.querySelector('.afr-quantity-reference-row');
      if (this.stock && this.quantityRow) { this.stockOrigin = document.createElement('template'); this.stock.before(this.stockOrigin); }
      this.paymentTabby = this.panel.querySelector('.afr-pdp-tabby-slot');
      this.paymentTamara = this.panel.querySelector('.afr-pdp-tamara-slot');
      if (this.paymentTabby && this.paymentTamara) {
        this.paymentOrigins = [this.paymentTabby, this.paymentTamara].map(slot => {
          const marker = document.createElement('template'); slot.before(marker); return marker;
        });
        this.paymentRow = document.createElement('div');
        this.paymentRow.className = 'afr-pdp-mobile-payment-row';
        this.paymentTabby.before(this.paymentRow);
        this.paymentMode = null;
        this.paymentDetails = [this.paymentTabby, this.paymentTamara].map(slot => slot.querySelector('.afr-payment-details'));
        this.paymentDetails.forEach(detail => detail?.addEventListener('toggle', () => {
          if (!detail.open) return;
          this.paymentDetails.forEach(other => { if (other !== detail && other.open) other.open = false; });
        }));

      }
      this.savings = this.panel.querySelector('afr-pdp-savings');
      if (this.savings) { this.savingsOrigin = document.createElement('template'); this.savings.before(this.savingsOrigin); }
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.updateLayout();
        });
      };
      this.reloadSection = event => {
        if (event.target?.classList?.contains('section-product-recommendations')) {
          this.related = window.Shopify?.designMode ? event.target.querySelector('.product-recommendations__wrapper') : event.target;
          if (!this.related) { this.schedule(); return; }
          this.related.classList.add('afr-pdp-related-section');
        }
        this.schedule();
      };
      this.unloadSection = event => {
        if (event.target?.contains(this)) this.restoreRelated();
      };
      document.addEventListener('DOMContentLoaded', this.schedule);
      document.addEventListener('shopify:section:load', this.reloadSection);
      document.addEventListener('shopify:section:unload', this.unloadSection);
      window.addEventListener('resize', this.schedule, { passive: true });
      this.mobile.addEventListener('change', this.schedule);
      this.header = document.querySelector('.section-header');
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.resizeObserver.observe(this.panel);
        if (this.header) this.resizeObserver.observe(this.header);
      }
      this.ratingObserver = new MutationObserver(this.schedule);
      this.ratingObserver.observe(this.panel, {childList:true,subtree:true});
      this.updateLayout();
    }
    updateLayout() {
      const brief = this.panel.querySelector('.afr-desktop-description-summary');
      if (brief && !this.descriptionGrid) {
        const price = this.panel.querySelector('.product-info__price-wrapper');
        const quantity = this.panel.querySelector('.afr-quantity-reference-row');
        if (price && quantity) {
          this.descriptionParts = [price, quantity, brief];
          this.descriptionOrigins = this.descriptionParts.map(node => { const marker = document.createElement('template'); node.before(marker); return marker; });
          this.descriptionGrid = document.createElement('div');
          this.descriptionGrid.className = 'afr-desktop-purchase-overview';
          this.descriptionPrimary = document.createElement('div');
          this.descriptionPrimary.className = 'afr-desktop-purchase-primary';
          this.descriptionGrid.append(this.descriptionPrimary);
          price.before(this.descriptionGrid);
        }
      }
      if (this.descriptionGrid) {
        if (!this.shippingColumnNode?.isConnected) {
          this.shippingColumnNode = this.panel.querySelector('.product-info__shipping-and-tax');
          if (this.shippingColumnNode) {
            this.shippingColumnOrigin?.remove();
            this.shippingColumnOrigin = document.createElement('template');
            this.shippingColumnNode.before(this.shippingColumnOrigin);
          }
        }
        const arrangeOverview = () => {
          if (this.shippingColumnNode && this.shippingColumnOrigin) {
            if (matchMedia('(min-width:1024px) and (max-width:1599px)').matches) {
              if (this.shippingColumnNode.parentNode !== this.descriptionGrid) this.descriptionGrid.append(this.shippingColumnNode);
            } else if (this.shippingColumnOrigin.parentNode && this.shippingColumnOrigin.nextSibling !== this.shippingColumnNode) {
              this.shippingColumnOrigin.after(this.shippingColumnNode);
            }
          }
          if (matchMedia('(min-width:1024px)').matches) {
            this.descriptionParts.slice(0,2).forEach(node => { if (node.parentNode !== this.descriptionPrimary) this.descriptionPrimary.append(node); });
            if (brief.parentNode !== this.descriptionGrid) this.descriptionGrid.append(brief);
          } else {
            this.descriptionParts.forEach((node,index) => { const origin = this.descriptionOrigins[index]; if (origin.parentNode && origin.nextSibling !== node) origin.after(node); });
          }
        };
        if (window.Alpine?.mutateDom) window.Alpine.mutateDom(arrangeOverview); else arrangeOverview();
      }
      if (this.paymentRow) {
        if (!this.paymentInitialized) {
          this.paymentInitialized = true;
          this.paymentDetails?.forEach(detail => { if (detail) detail.open = false; });
        }
        const arrangePayments = () => {
          [this.paymentTabby, this.paymentTamara].forEach(slot => {
            if (slot.parentNode !== this.paymentRow) this.paymentRow.append(slot);
          });
        };
        if (window.Alpine?.mutateDom) window.Alpine.mutateDom(arrangePayments);
        else arrangePayments();
      }
      const currentRating = this.panel.querySelector('.afr-pdp-price-row .afr-pdp-title-rating') || this.panel.querySelector('.afr-pdp-title-rating');
      if (currentRating && currentRating !== this.titleRating) {
        this.titleRating = currentRating;
        this.ratingOrigin?.remove();
        this.ratingOrigin = document.createElement('template');
        currentRating.before(this.ratingOrigin);
      }
      this.brandRow = this.panel.querySelector('.afr-pdp-brand') || this.brandRow;
      if (!this.related?.isConnected) {
        const source = Array.from(document.querySelectorAll('.section-product-recommendations')).find(node => !node.closest('afr-pdp-layout') && (this.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING));
        const related = window.Shopify?.designMode ? source?.querySelector('.product-recommendations__wrapper') : source;
        if (related) {
          this.origin?.remove();
          this.origin = document.createElement('template');
          related.before(this.origin);
          this.related = related;
          this.related.classList.add('afr-pdp-related-section');
        }
      }
      if (this.titleRating && this.brandRow) {
        if (this.titleRating.parentNode !== this.brandRow) this.brandRow.append(this.titleRating);
      }
      if (this.stock && this.quantityRow && this.stock.parentNode !== this.quantityRow) this.quantityRow.append(this.stock);
      if (this.savings) {
        if (this.mobile.matches) { if (this.savings.parentNode !== this.page) this.page.insertBefore(this.savings, this.content); }
        else if (this.savingsOrigin?.parentNode && this.savings.previousSibling !== this.savingsOrigin) this.savingsOrigin.after(this.savings);
      }
      const destination = this.mobile.matches ? this.page : this.media;
      if (this.reviews && this.reviews.parentNode !== destination) destination.append(this.reviews);
      if (this.related && this.related.parentNode !== destination) destination.append(this.related);
      if (window.Shopify?.designMode && this.related) {
        const region = this.related.querySelector('.product-recommendations[data-afr-section-id]');
        const loader = window.Alpine?.store('xProductRecommendations');
        if (region && !region.dataset.afrEditorStarted && loader) {
          region.dataset.afrEditorStarted = 'true';
          loader.load(region, region.dataset.afrSectionId, region.dataset.afrProductId, Number(region.dataset.afrLimit) || 10, 'related', true);
        }
      }
      this.syncMobileMetadata();
      const headerHeight = Math.ceil(this.header?.getBoundingClientRect().height || 0);
      const panelHeight = Math.ceil(this.panel.getBoundingClientRect().height);
      const top = Math.min(headerHeight + 16, window.innerHeight - panelHeight - 16);
      this.style.setProperty('--afr-pdp-sticky-top', `${top}px`);
      this.style.setProperty('--afr-pdp-header-offset', `${headerHeight + 16}px`);
      this.dataset.ready = 'true';
    }
    syncMobileMetadata() {
      const sku = this.panel.querySelector('.product-info__identifier-wrapper');
      const link = this.panel.querySelector('.afr-mobile-buy-more-inline');
      if (!sku || !link) return;
      const arrange = () => {
        if (this.metadataSku !== sku || this.metadataLink !== link) {
          this.metadataSkuOrigin?.remove();
          this.metadataLinkOrigin?.remove();
          this.metadataRow?.remove();
          this.metadataSku = sku;
          this.metadataLink = link;
          this.metadataSkuOrigin = document.createElement('template');
          this.metadataLinkOrigin = document.createElement('template');
          sku.before(this.metadataSkuOrigin);
          link.before(this.metadataLinkOrigin);
          this.metadataRow = document.createElement('div');
          this.metadataRow.className = 'afr-mobile-sku-shipping-row';
        }
        if (this.mobile.matches) {
          if (!this.metadataRow.isConnected) this.metadataLinkOrigin.after(this.metadataRow);
          if (sku.parentNode !== this.metadataRow) this.metadataRow.append(sku);
          if (link.parentNode !== this.metadataRow) this.metadataRow.append(link);
        } else {
          if (this.metadataSkuOrigin.parentNode && sku.previousSibling !== this.metadataSkuOrigin) this.metadataSkuOrigin.after(sku);
          if (this.metadataLinkOrigin.parentNode && link.previousSibling !== this.metadataLinkOrigin) this.metadataLinkOrigin.after(link);
          this.metadataRow.remove();
        }
      };
      if (window.Alpine?.mutateDom) window.Alpine.mutateDom(arrange);
      else arrange();
    }
    restoreRelated() {
      if (this.related && this.origin?.isConnected) {
        this.origin.replaceWith(this.related);
        this.related.classList.remove('afr-pdp-related-section');
      }
      this.origin?.remove();
      this.related = null;
      this.origin = null;
    }
    disconnectedCallback() {
      if (!this.schedule) return;
      cancelAnimationFrame(this.frame);
      this.frame = null;
      this.resizeObserver?.disconnect();
      this.ratingObserver?.disconnect();
      document.removeEventListener('DOMContentLoaded', this.schedule);
      document.removeEventListener('shopify:section:load', this.reloadSection);
      document.removeEventListener('shopify:section:unload', this.unloadSection);
      window.removeEventListener('resize', this.schedule);
      this.mobile?.removeEventListener('change', this.schedule);
      this.restoreRelated();
    }
  }
  customElements.define('afr-pdp-layout', AfrPdpLayout);
}
if (!customElements.get('afr-price-countdown')) {
  customElements.define('afr-price-countdown', class extends HTMLElement {
    connectedCallback() {
      const from = Number(this.dataset.from), to = Number(this.dataset.to);
      const final = this.querySelector('.afr-countdown-final');
      if (!(from > to && to >= 0) || !final) return;
      const text = this.dataset.finalText || final.textContent;
      const parts = text.match(/^(.*?)([0-9][0-9.,]*)(.*)$/s);
      if (!parts) return;
      const affix = value => {
        const node = document.createElement('span');
        node.textContent = value;
        if (value.includes('AED')) {
          node.className = 'afr-price-currency';
          node.style.setProperty('font-size', 'var(--afr-pdp-currency-size,1em)', 'important');
        }
        return node;
      };
      const number = parts[2];
      const separator = number.match(/[.,][0-9]{2}$/);
      const decimalIndex = separator ? separator.index : number.length;
      const digits = number.replace(/\D/g, '');
      const previous = String(Math.round(from));
      const startDigits = previous.length === digits.length ? previous : digits;
      const build = animated => {
        const fragment = document.createDocumentFragment();
        fragment.append(affix(parts[1]));
        const integer = document.createElement('span');
        const decimal = document.createElement('span');
        decimal.className = 'afr-price-decimal';
        let digitIndex = 0;
        Array.from(number).forEach((character, index) => {
          const parent = index < decimalIndex ? integer : decimal;
          if (!animated || !/[0-9]/.test(character)) {
            parent.append(document.createTextNode(character));
            return;
          }
          const reel = document.createElement('span');
          reel.style.cssText = 'display:inline-grid;position:relative;overflow:hidden;vertical-align:baseline;line-height:inherit;isolation:isolate';
          const outgoing = document.createElement('span');
          const incoming = document.createElement('span');
          outgoing.textContent = startDigits[digitIndex];
          outgoing.setAttribute('aria-hidden', 'true');
          incoming.textContent = character;
          outgoing.style.cssText = incoming.style.cssText = 'grid-area:1/1;display:block;line-height:inherit';
          reel.append(outgoing, incoming);
          parent.append(reel);
          const delay = digitIndex * 35;
          const options = {duration:620, delay, easing:'cubic-bezier(.22,.75,.2,1)', fill:'both'};
          this.animations.push(outgoing.animate([
            {transform:'translateY(0)', opacity:1},
            {transform:'translateY(-110%)', opacity:0}
          ], options));
          this.animations.push(incoming.animate([
            {transform:'translateY(110%)', opacity:0},
            {transform:'translateY(0)', opacity:1}
          ], options));
          digitIndex += 1;
        });
        fragment.append(integer);
        if (separator) fragment.append(decimal);
        fragment.append(affix(parts[3]));
        return fragment;
      };
      const settle = () => {
        if (!this.isConnected) return;
        final.replaceChildren(build(false));
        delete this.dataset.running;
        this.style.removeProperty('color');
        this.dataset.done = 'true';
        this.animations = [];
      };
      this.animations = [];
      if (matchMedia('(prefers-reduced-motion:reduce)').matches || !Element.prototype.animate) {
        settle();
        return;
      }
      this.dataset.running = 'true';
      final.replaceChildren(build(true));
      Promise.all(this.animations.map(animation => animation.finished)).then(settle).catch(() => {});
    }
    disconnectedCallback() {
      this.animations?.forEach(animation => animation.cancel());
      this.animations = [];
      delete this.dataset.running;
    }
  });
}


if (!customElements.get('afr-button-total')) {
 customElements.define('afr-button-total', class extends HTMLElement {
  connectedCallback(){
   this.unit=Number(this.dataset.unit); this.quantity=1; this.available=this.dataset.available==='true';
   this.renderTotal=()=>{ this.hidden=!this.available || !Number.isFinite(this.unit) || !(this.quantity>0); const value=new Intl.NumberFormat(document.documentElement.lang||'en',{minimumFractionDigits:2,maximumFractionDigits:2}).format(this.unit*this.quantity/100); if(this.textContent!==value)this.textContent=value; };
   this.onQuantity=e=>{if(e.detail?.sectionId===this.dataset.section){this.quantity=Number(e.detail.quantity);this.renderTotal();}};
   this.onVariant=e=>{const v=e.detail?.currentVariant;this.unit=Number(v?.price);this.available=!!v?.available;this.renderTotal();};
   document.addEventListener('afr-quantity-total',this.onQuantity);
   if(typeof PRODUCT_EVENT!=='undefined'){this.variantEvent=PRODUCT_EVENT.updatedVariant+this.dataset.section;document.addEventListener(this.variantEvent,this.onVariant);}
   const page=this.closest('.afr-pdp-page');
   this.totalPage=page;
   this.syncInput=()=>{cancelAnimationFrame(this.totalFrame);this.totalFrame=requestAnimationFrame(()=>{const q=page?.querySelector('.product-info__quantity-wrapper input[name="quantity"]');if(q){this.quantity=Number(q.value);this.renderTotal();}});};
   page?.addEventListener('input',this.syncInput);
   page?.addEventListener('change',this.syncInput);
   this.onQuantityClick=e=>{if(e.target.closest('[name="plus"],[name="minus"]'))this.syncInput();};
   page?.addEventListener('click',this.onQuantityClick);
   const input=page?.querySelector('.product-info__quantity-wrapper input[name="quantity"]');if(input)this.quantity=Number(input.value)||1;
   this.renderTotal();
  }
  disconnectedCallback(){cancelAnimationFrame(this.totalFrame);this.totalPage?.removeEventListener('input',this.syncInput);this.totalPage?.removeEventListener('change',this.syncInput);this.totalPage?.removeEventListener('click',this.onQuantityClick);document.removeEventListener('afr-quantity-total',this.onQuantity);if(this.variantEvent)document.removeEventListener(this.variantEvent,this.onVariant);}
 });
}

if (!customElements.get('afr-quantity-saving')) {
 customElements.define('afr-quantity-saving', class extends HTMLElement {
  connectedCallback(){
   this.unit=Number(this.dataset.unit);this.compare=Number(this.dataset.compare);this.quantity=1;
   const page=this.closest('.afr-pdp-page');
   this.updateSaving=()=>{
    const input=page?.querySelector('.product-info__quantity-wrapper input[name="quantity"]');
    const q=Number(input?.value);
    if(Number.isFinite(q)&&q>0)this.quantity=q;
    const subtotal=this.unit*this.quantity;
    const shipping=subtotal>=50000;
    const amount=Math.max(0,this.compare-this.unit)*this.quantity+(shipping?3500:0);
    this.hidden=!(amount>0);
    this.style.setProperty('display',amount>0?'var(--afr-saving-display,revert-layer)':'none','important');
    this.classList.toggle('afr-saving-with-shipping',shipping);
    const ar=document.documentElement.lang?.startsWith('ar');
    const strong=this.querySelector('strong'), text=this.querySelector(':scope>span');
    const value=new Intl.NumberFormat(ar?'ar-AE':'en-AE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(amount/100);
    if(strong){const label=(ar?'وفّر ':'Save ')+value+(ar?' درهم':' AED');if(strong.textContent!==label)strong.textContent=label;}
    if(text){const label=shipping?(ar?'يشمل توفير الشحن · الشحن مجاني':'incl. shipping savings · Free shipping'):(ar?'على الكمية المختارة':'on selected quantity');if(text.textContent!==label)text.textContent=label;}
   };
   this.scheduleSaving=()=>{cancelAnimationFrame(this.savingFrame);this.savingFrame=requestAnimationFrame(this.updateSaving);};
   this.onQty=e=>{if(e.detail?.sectionId===this.dataset.section){this.quantity=Number(e.detail.quantity)||1;this.scheduleSaving();}};
   this.onVariant=e=>{const v=e.detail?.currentVariant;this.unit=Number(v?.price)||0;this.compare=Number(v?.compare_at_price)||0;this.scheduleSaving();};
   this.onClick=e=>{if(e.target.closest('[name="plus"],[name="minus"]'))this.scheduleSaving();};
   this.savingPage=page;
   page?.addEventListener('input',this.scheduleSaving);page?.addEventListener('change',this.scheduleSaving);page?.addEventListener('click',this.onClick);
   document.addEventListener('afr-quantity-total',this.onQty);
   if(typeof PRODUCT_EVENT!=='undefined'){this.variantEvent=PRODUCT_EVENT.updatedVariant+this.dataset.section;document.addEventListener(this.variantEvent,this.onVariant);}
   this.updateSaving();
  }
  disconnectedCallback(){cancelAnimationFrame(this.savingFrame);this.savingPage?.removeEventListener('input',this.scheduleSaving);this.savingPage?.removeEventListener('change',this.scheduleSaving);this.savingPage?.removeEventListener('click',this.onClick);document.removeEventListener('afr-quantity-total',this.onQty);if(this.variantEvent)document.removeEventListener(this.variantEvent,this.onVariant);}
 });
}
